$(document).ready(function () {
    function closeCartModal() {
        $('#add-to-cart-success-modal').removeClass('open');
        location.reload();
    }

    $('#closeAddToCartModal, #continueShoppingBtn, .vivense-modal-overlay').on('click', function () {
        closeCartModal();
    });

    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            closeCartModal();
        }
    });
});